import { AddGiftCardScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <AddGiftCardScreen />;
}
